import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";
import Hero from "../../components/accomodation/hero/Hero";
import Footer from "../../components/layout/Footer";
import { IMAGES } from "../../data/images";
import Promise from "../../components/accomodation/promise/Promise";
import Faq from "../../components/accomodation/faq/Faq";
import promise1 from "../../assets/images/promise1.webp";
import promise2 from "../../assets/images/promise2.webp";
import promise3 from "../../assets/images/promise3.webp";
import { FAQS } from "../../data/faqs";

const promises = [
  {
    image: promise1,
    title: "Pre-Activated SIM",
    description:
      "Receive your SIM card at your Indian address, activated and ready before departure.",
  },
  {
    image: promise2,
    title: "Affordable Plans",
    description:
      "Data and calling plans tailored for students — from 5GB to unlimited options.",
  },
  {
    image: promise3,
    title: "Multi-Country Coverage",
    description:
      "SIM cards available for USA, Canada, UK, Australia, New Zealand, and Europe.",
  },
];

function Sim() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero
        img={IMAGES.internationalSimCard}
        heading="International SIM Cards"
        description="Stay connected from the moment you land in your dream destination."
      />
      <Promise
        heading="Why Choose Our SIM Cards"
        description="Get a student SIM activated before you leave India. Text, call, and browse the internet freely — never be out of reach of family and friends."
        promises={promises}
      />
      <Faq data={FAQS.sim} />
      <div className="text-center py-8">
        <button
          onClick={() => navigate("/pricing")}
          className="bg-blue-600 text-white py-3 px-8 rounded-lg hover:bg-blue-700 font-semibold"
        >
          Order SIM Card — ₹1,499
        </button>
      </div>
      <Footer />
    </>
  );
}

export default Sim;
